import React from "react";
import {
  Box,
  Paper,
  Stack,
  Typography,
  MobileStepper,
  Button,
  ArrowRightIcon,
  ArrowLeftIcon,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const DotStepper = () => {
  const [activeStep, setActiveStep] = React.useState(0);
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Dots
        </Typography>
        <Typography variant={"body1"} color={"text.primary"}>
          Use dots when the number of steps is small.
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor
            language={"js"}
            value={
              "" +
              "  const [activeStep, setActiveStep] = React.useState(0);\n" +
              "  const handleNext = () => {\n" +
              "    setActiveStep((prevActiveStep) => prevActiveStep + 1);\n" +
              "  };\n" +
              "  const handleBack = () => {\n" +
              "    setActiveStep((prevActiveStep) => prevActiveStep - 1);\n" +
              "  };" +
              "            <MobileStepper\n" +
              '              variant="dots"\n' +
              "              steps={6}\n" +
              '              position="static"\n' +
              "              activeStep={activeStep}\n" +
              "              sx={{ maxWidth: 400, flexGrow: 1 }}\n" +
              "              nextButton={\n" +
              "                <Button\n" +
              '                  variant="text"\n' +
              '                  size="small"\n' +
              "                  onClick={handleNext}\n" +
              "                  disabled={activeStep === 5}\n" +
              "                  endIcon={<ArrowRightIcon />}\n" +
              "                >\n" +
              "                  Next\n" +
              "                </Button>\n" +
              "              }\n" +
              "              backButton={\n" +
              "                <Button\n" +
              '                  variant="text"\n' +
              '                  size="small"\n' +
              "                  onClick={handleBack}\n" +
              "                  disabled={activeStep === 0}\n" +
              "                  startIcon={<ArrowLeftIcon />}\n" +
              "                >\n" +
              "                  Back\n" +
              "                </Button>\n" +
              "              }\n" +
              "            />"
            }
          >
            <MobileStepper
              variant="dots"
              steps={6}
              position="static"
              activeStep={activeStep}
              sx={{ maxWidth: 400, flexGrow: 1 }}
              nextButton={
                <Button
                  variant="text"
                  size="small"
                  onClick={handleNext}
                  disabled={activeStep === 5}
                  endIcon={<ArrowRightIcon />}
                >
                  Next
                </Button>
              }
              backButton={
                <Button
                  variant="text"
                  size="small"
                  onClick={handleBack}
                  disabled={activeStep === 0}
                  startIcon={<ArrowLeftIcon />}
                >
                  Back
                </Button>
              }
            />
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default DotStepper;
